import {
  createApiRef,
  DiscoveryApi,
  IdentityApi,
} from '@backstage/core-plugin-api';
import { NpsScoreResponse } from './hooks/useNpsScore';
import { SecurityScoreResponse } from './hooks/useSecurityScore';

export interface ScorecardApi {
  getSecurityScore(entityRef: string): Promise<SecurityScoreResponse>; 
  getNPSScore(entityRef: string): Promise<NpsScoreResponse>; 
}

export const scoreCardApiRef = createApiRef<ScorecardApi>({
  id: 'plugin.score-card.service',
});

export class ScorecardApiClient implements ScorecardApi {
  constructor(
    private readonly discoveryApi: DiscoveryApi,
    private readonly identityApi: IdentityApi,
  ) {}

  async getSecurityScore(entityRef: string): Promise<SecurityScoreResponse> {
    const baseUrl = await this.discoveryApi.getBaseUrl('score-card');
    const { token } = await this.identityApi.getCredentials();

    const res = await fetch(
      `${baseUrl}/security-score?entityRef=${encodeURIComponent(entityRef)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    const data = await res.json();

    if (!res.ok) {
      const errorMessage = data?.error || res.statusText;
      throw new Error(errorMessage);
    }

    return data as SecurityScoreResponse;
  }

  async getNPSScore(entityRef: string): Promise<NpsScoreResponse> {
    const baseUrl = await this.discoveryApi.getBaseUrl('score-card');
    const { token } = await this.identityApi.getCredentials();

    const res = await fetch(
      `${baseUrl}/nps-score?entityRef=${encodeURIComponent(entityRef)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    const data = await res.json();

    if (!res.ok) {
      const errorMessage = data?.error || res.statusText;
      throw new Error(errorMessage);
    }

    return data as NpsScoreResponse;
  }
}
